import React, { useRef, useState } from "react"

import PropTypes from "prop-types"
import {
  Alert,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap"

const DefaultForm = ({ onSubmit, onCancel }) => {
  const noteInputRef = useRef(null)
  const fileRef = useRef(null)
  const [file, setFile] = useState(null)

  const onFormSubmit = e => {
    e.preventDefault()
    const note = noteInputRef.current.value

    if (typeof onSubmit === "function") onSubmit(note, file)
  }

  return (
    <form onSubmit={onFormSubmit} className="w-100">
      <Row>
        <Col>
          <fieldset>
            <FormGroup controlid="anexo">
              <Label>Anexo:</Label>
              <InputGroup>
                <Input
                  innerRef={fileRef}
                  className="form-control"
                  type="file"
                  onChange={e => {
                    setFile(e.target.files[0])
                  }}
                />
                <Button
                  onClick={() => {
                    fileRef.current.value = ""
                    fileRef.current.files = null
                    setFile(null)
                  }}
                >
                  X
                </Button>
              </InputGroup>
            </FormGroup>
          </fieldset>
        </Col>
      </Row>
      <div className="form-group">
        <label>Adicione anotações à solicitação de suporte:</label>
        <textarea className="form-control" rows="5" ref={noteInputRef} />
      </div>
      <div className="form-group d-flex justify-content-between mt-2">
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={e => {
            e.preventDefault()
            if (typeof onCancel === "function") onCancel()
          }}
        >
          Cancelar
        </button>

        <button type="submit" className="btn btn-primary">
          Enviar solicitação
        </button>
      </div>
    </form>
  )
}

DefaultForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
}

export default DefaultForm
